import { NewDepot } from "./components/NewDepot";

export default NewDepot;